import { atlassianTheme } from './atlassian-theme';
import { type NavigationTheme } from './types';

export const defaultTheme: NavigationTheme = atlassianTheme;

export { atlassianTheme } from './atlassian-theme';
